import TermsConditionsContent from "../../components/Settings/TermsConditionsContent";
import NavSettings from "../../components/common/NavSettings";

const TermsConditions = () => {
  return (
    <>
      <NavSettings title="Mi perfil" route="Inicio" active="Terminos y condiciones" />

      <TermsConditionsContent />
    </>
  );
};

export default TermsConditions;
